export default __webpack_public_path__ + "dc12a25329e83f8da4997c8e8790c622.svg";